import { apiFetch } from "./client.ts";

export interface AiJob {
  id: string;
  workflowRunId: string | null;
  stepRunId: string | null;
  agentName: string;
  correlationId: string;
  status: string;
  priority: string;
  model: string | null;
  input: unknown;
  output: unknown;
  errorMessage: string | null;
  retryCount: number;
  maxRetries: number;
  tokensUsed: number | null;
  durationMs: number | null;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
}

export interface JobLog {
  id: string;
  level: string;
  message: string;
  metadata: unknown;
  createdAt: string;
}

export async function listJobs(
  token: string,
  params: { status?: string; agentName?: string; workflowRunId?: string; limit?: number } = {},
): Promise<AiJob[]> {
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", params.status);
  if (params.agentName) qs.set("agentName", params.agentName);
  if (params.workflowRunId) qs.set("workflowRunId", params.workflowRunId);
  if (params.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return apiFetch<AiJob[]>(`/api/v1/jobs${query}`, { token });
}

export async function getJob(token: string, id: string): Promise<AiJob & { logs: JobLog[] }> {
  return apiFetch<AiJob & { logs: JobLog[] }>(`/api/v1/jobs/${id}`, { token });
}
